import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const EyeIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

/**
 * Campo password con l'occhio per vedere quello che si sta scrivendo
 * (usato da Profilo, Utenti e Utenti dell'azienda). Stili: .password-input-wrapper / .password-toggle.
 */
function KernelPasswordField({ label, value, onChange, required, autoComplete, style }) {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  const toggleTitle = visible ? t('profile.hidePassword') : t('profile.showPassword');
  return (
    <div className="form-group" style={style}>
      <label>{label}</label>
      <div className="password-input-wrapper">
        <input
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          required={required}
          autoComplete={autoComplete}
        />
        <button
          type="button"
          className={'password-toggle' + (visible ? ' is-off' : '')}
          onClick={() => setVisible((v) => !v)}
          title={toggleTitle}
          aria-label={toggleTitle}
          aria-pressed={visible}
        >
          {visible ? EyeOffIcon : EyeIcon}
        </button>
      </div>
    </div>
  );
}

export default KernelPasswordField;
